export enum PaymentMethod {
    CASH = '1',
    CARD_PAYMENT = '2'
}